module.exports = __webpack_public_path__ + "img/index-section7-award3.b7c01c10.png";